export default __webpack_public_path__ + "static/media/search-clear.c31567a6.svg";